import { render, staticRenderFns } from "./PatentTransactionReport.vue?vue&type=template&id=14ae9131&"
import script from "./PatentTransactionReport.vue?vue&type=script&lang=js&"
export * from "./PatentTransactionReport.vue?vue&type=script&lang=js&"
import style0 from "./PatentTransactionReport.vue?vue&type=style&index=0&id=14ae9131&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports